/* Klaviyo "Added to Cart" — trigger metric for the Abandoned Cart flow.
   Same seam as sola-cart.js: udesly posts /cart/add via XHR (quick-add uses
   fetch); on success we read /cart.js (items[0] = most recently added) and
   track once per add. */
(function () {
  'use strict';
  var last = 0;
  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url || ''); }
  function money(cents) { return Math.round(cents) / 100; }

  function track() {
    if (!window.klWhenReady) return;
    var now = Date.now();
    if (now - last < 800) return; // udesly can double-fire on one add
    last = now;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var a = cart.items[0];
        klWhenReady(function () {
        klaviyo.push(['track', 'Added to Cart', {
          $value: money(cart.total_price),
          AddedItemProductName: a.product_title,
          AddedItemProductID: a.product_id,
          AddedItemSKU: a.sku,
          AddedItemVariantName: a.variant_title,
          AddedItemImageURL: a.image,
          AddedItemURL: location.origin + a.url,
          AddedItemPrice: money(a.price),
          AddedItemQuantity: a.quantity,
          ItemNames: cart.items.map(function (i) { return i.product_title; }),
          CheckoutURL: location.origin + '/cart',
          Items: cart.items.map(function (i) {
            return {
              ProductID: i.product_id,
              ProductName: i.product_title,
              VariantName: i.variant_title,
              SKU: i.sku,
              Quantity: i.quantity,
              ItemPrice: money(i.price),
              RowTotal: money(i.final_line_price),
              ImageURL: i.image,
              URL: location.origin + i.url
            };
          })
        }]);
        });
      })
      .catch(function () {});
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__klAdd = ((method || '').toUpperCase() === 'POST') && isAdd(url);
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__klAdd) {
      var xhr = this;
      xhr.addEventListener('loadend', function () {
        if (xhr.status >= 200 && xhr.status < 300) track();
      });
    }
    return origSend.apply(this, arguments);
  };

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = origFetch.apply(this, arguments);
      if (method === 'POST' && isAdd(url)) {
        p.then(function (res) { if (res && res.ok) track(); }).catch(function () {});
      }
      return p;
    };
  }
})();
